const INITIAL_STATE = {
  layout: true
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_LAYOUT":
      return { ...state, layout: action.payload };
    default:
      return state;
  }
};
